import { render, staticRenderFns } from "./TabsEvent.vue?vue&type=template&id=61803cdb"
import script from "./TabsEvent.vue?vue&type=script&lang=ts"
export * from "./TabsEvent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports